/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "classapi",
            "endpoint": "https://d5jrsdxat2.execute-api.us-west-1.amazonaws.com/infuse",
            "region": "us-west-1"
        },
        {
            "name": "sendemailapi",
            "endpoint": "https://uwlmju4bz6.execute-api.us-west-1.amazonaws.com/infuse",
            "region": "us-west-1"
        }
    ],
    "aws_content_delivery_bucket": "classificationapp-20230420182258-hostingbucket-infuse",
    "aws_content_delivery_bucket_region": "us-west-1",
    "aws_content_delivery_url": "https://d1t7gopqvgoszd.cloudfront.net"
};


export default awsmobile;
